import React, { lazy } from 'react';
import { useTrackSection } from '../utils/useTrackSection';
const cld = (path: string) => `https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_180/${path}`;
const tomes = [{
  number: '01',
  sublabel: 'Primera Consulta',
  desc: 'Estructura en 5 etapas: apertura, relevamiento, prioridades, enfoque y cierre con próximos pasos concretos.',
  image: cld('v1779330121/hf_20260521_003226_65703239-5516-43cd-ad3f-b4085e790bf6_pv6jhc.webp'),
  alt: 'Tomo 1 — Primera Consulta'
}, {
  number: '02',
  sublabel: 'Diseño del Plan',
  desc: 'Base repetible adaptada a barreras reales del paciente: tiempo, logística, emociones y nivel de complejidad sostenible.',
  image: cld('v1779330123/hf_20260521_004347_60af8bea-f6d4-43cd-b8be-57b623628a7b_oaxzcf.webp'),
  alt: 'Tomo 2 — Diseño del Plan'
}, {
  number: '03',
  sublabel: 'Seguimiento',
  desc: 'Cada control produce una decisión: sostener, ajustar o simplificar. Adherencia, síntomas y comprensión, no solo el peso.',
  image: cld('v1779330128/hf_20260521_021358_2bee0cb1-ec46-4938-aecf-84d40ae67f60_g9k531.webp'),
  alt: 'Tomo 3 — Seguimiento'
}, {
  number: '04',
  sublabel: 'Educación Alimentaria',
  desc: 'Educar es parte del tratamiento. Un foco por sesión, dosificado y verificado con ejemplos cotidianos.',
  image: cld('v1779330131/hf_20260521_020929_33937014-a79c-4998-8399-7890f1ed1207_wryy1j.webp'),
  alt: 'Tomo 4 — Educación Alimentaria'
}, {
  number: '05',
  sublabel: 'Consulta Real',
  desc: 'Leer barreras sin culpar, adaptar el plan al contexto cotidiano y distinguir "no puede" de "no quiere".',
  image: cld('v1779330134/hf_20260521_020749_48b03105-419f-4765-83c0-2aeecd9abe20_cbt0q7.webp'),
  alt: 'Tomo 5 — Consulta Real'
}, {
  number: '06',
  sublabel: 'Sistema Profesional',
  desc: 'Flujo por etapas, registro útil, estructura de consulta y continuidad planificada entre sesiones.',
  image: cld('v1779330136/hf_20260521_021826_723860d2-3d10-42db-8d0a-b6678912ecd3_ecpsoq.webp'),
  alt: 'Tomo 6 — Sistema Profesional'
}];
export function ProductShowcase() {
  useTrackSection('product-showcase', 'Product Showcase Section');
  return <section id="product-showcase" className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(248,250,252) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 75%, rgb(240,253,244) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-263">
      <div className="mx-auto max-w-4xl text-center" data-id="element-264">
        {/* Badge */}
        <div className="mb-4 inline-flex items-center gap-2 text-xs font-bold tracking-wide rounded-full px-4 py-1.5 border border-green-600/50 bg-green-700/5 text-green-700" data-id="element-265">
          🏆 El sistema clínico más completo para nutricionistas de Argentina
        </div>

        {/* Title */}
        <h2 className="text-2xl font-black text-gray-900 m-0 mb-2" data-id="element-266">
          MEGAPACK NUTRICIÓN RESUELTA
        </h2>

        {/* Subtitle */}
        <p className="text-sm font-semibold text-gray-700 m-0 mb-1" data-id="element-267">
          6 Tomos + 6 Bonos — Sistema Clínico Completo — Todo resuelto.
        </p>
        <p className="text-sm text-gray-500 m-0 mb-8" data-id="element-268">
          +350 páginas · Primera consulta estructurada · Diseño de plan adaptado
          · Seguimiento con decisiones clínicas · Educación alimentaria
          dosificada · Sistema de consultorio · Listo para usar hoy.
        </p>

        {/* Tomes Grid */}
        <div className="grid grid-cols-6 gap-3 mb-4" data-id="element-269">
          {tomes.map(tome => <div key={tome.number} className="flex flex-col items-center gap-2" data-id="element-270">
              <div className="w-full aspect-[3/4] rounded-xl overflow-hidden shadow-md border border-green-700/20" data-id="element-271">
                <img src={tome.image} alt={tome.alt} width={180} height={240} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-272" />
              </div>
              <div className="text-center" data-id="element-273">
                <span className="block font-black text-gray-900 text-[10px]" data-id="element-274">
                  Tomo {tome.number}
                </span>
                <span className="block text-[9px] text-gray-500 leading-tight mt-0.5" style={{
              wordBreak: 'break-word',
              hyphens: 'auto'
            }} data-id="element-275">
                  {tome.sublabel}
                </span>
              </div>
            </div>)}
        </div>

        {/* Badge inferior */}
        <div className="flex justify-center mb-8" data-id="element-276">
          <div className="bg-green-700 text-[10px] font-black text-white rounded-full px-4 py-1.5" data-id="element-277">
            6 TOMOS COMPLETOS · SISTEMA CLÍNICO PROFESIONAL
          </div>
        </div>

        {/* Tomes list */}
        <div className="bg-white border border-green-600/20 rounded-xl overflow-hidden shadow-sm" data-id="element-278">
          <div className="bg-green-700 px-5 py-3 text-left" data-id="element-279">
            <h3 className="text-sm font-black text-white m-0" data-id="element-280">
              📚 LOS 6 TOMOS — Sistema Clínico de Consulta Nutricional
            </h3>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-281">
            {tomes.map(tome => <div key={tome.number} className="flex items-center gap-4 px-5 py-3" data-id="element-282">
                <span className="shrink-0 text-lg font-black text-green-700/30 w-8 text-center" data-id="element-283">
                  {tome.number}
                </span>
                <div className="flex-1 min-w-0 text-left" data-id="element-284">
                  <span className="block text-sm font-black text-gray-900" data-id="element-285">
                    {tome.sublabel}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-286">
                    {tome.desc}
                  </span>
                </div>
                <span className="shrink-0 text-[10px] font-bold text-green-700 bg-green-700/5 border border-green-600/20 rounded-full px-2 py-0.5 whitespace-nowrap" data-id="element-287">
                  Tomo {tome.number}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}